<app-top-menu></app-top-menu>
<router-outlet></router-outlet> <!--<app-special-thanks></app-special-thanks>--> <!--app-home  --> <!-- app-search --> <!--app-irr -->
<app-footer></app-footer>
